import {cn} from '@sollapay/ui';

import type {FC, ReactNode} from 'react';

export interface LegalContainerProps {
  children: ReactNode;
  className?: string;
}

export const LegalContainer: FC<LegalContainerProps> = ({children, className}) => {
  return (
    <div
      data-slot="legal-container"
      className={cn('mx-auto w-full max-w-3xl px-6 lg:px-10', className)}
    >
      {children}
    </div>
  );
};
